import { render, staticRenderFns } from "./ModelLoading.vue?vue&type=template&id=a3fda828&scoped=true"
import script from "./ModelLoading.vue?vue&type=script&lang=js"
export * from "./ModelLoading.vue?vue&type=script&lang=js"
import style0 from "./ModelLoading.vue?vue&type=style&index=0&id=a3fda828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fda828",
  null
  
)

export default component.exports